import { Injectable, inject } from '@angular/core';
import { Samples, Samples_Insert_Input } from '@etoh/database/core';
import { addMonths } from 'date-fns';
import { sortBy } from 'lodash';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { Observable, take, tap } from 'rxjs';
import { RxjsOperatorsService } from '../../rxjs-operators.service';
import { UserService } from '../../user.service';
import { ListAction } from '../shared/interfaces/listOptions.interface';
import { storeConfigurationBulkConfigState } from '../store.interface';
import { StoreService } from '../store.service';
import { GenerateSampleLabelPdfComponent } from './containers/generate-sample-label-pdf/generate-sample-label-pdf.component';

@Injectable({
  providedIn: 'root',
})
export class SamplesService {
  private userService = inject(UserService);
  private storeService = inject(StoreService);
  private rxjsOperatorsService = inject(RxjsOperatorsService);
  private drawerService = inject(NzDrawerService);

  actionsOnSelections: ListAction<Samples>[] = [
    {
      name: 'Print sample labels',
      action: (samples) => {
        this.quickView(
          sortBy(
            samples.map((s) => s.id),
            (id) => id
          )
        );
      },
    },
  ];

  private quickView(samplesId: number[]) {
    const drawerRef = this.drawerService.create<
      GenerateSampleLabelPdfComponent,
      { samplesId: number[]; standalone: boolean },
      string
    >({
      nzTitle: 'Print sample labels',
      nzSize: 'large',
      nzContent: GenerateSampleLabelPdfComponent,
      nzContentParams: {
        samplesId,
        standalone: false,
      },
    });

    drawerRef.afterOpen.subscribe(() => {
      console.log('Drawer(Component) open');
    });

    drawerRef.afterClose.subscribe((data) => {
      console.log(data);
    });
  }

  getSampleAddInitialState(): Samples_Insert_Input {
    return {
      createdAt: new Date().toISOString(),
      samplingDate: new Date().toISOString(),
      reminderForExpiration: addMonths(new Date(), 2).toISOString(),
      compositionCertificates: [],
      analysisCertificates: [],
      samplePictures: [],
      createdBy: this.userService.userId$.value,
      sampledBy: this.userService.userId$.value,
      officeId: this.userService.userOfficeId$.value,
    };
  }

  public insertSample(
    model: Samples_Insert_Input,
    numberOfSampleToCreate: number
  ): Observable<any> {
    return this.rxjsOperatorsService
      .bulkOperator(
        new Array(numberOfSampleToCreate)
          .fill(0)
          .map(() =>
            this.storeService.addObject<Samples>(
              'samples',
              model as any,
              storeConfigurationBulkConfigState
            )
          )
      )
      .pipe(
        take(1),
        tap(() => {
          this.storeService.propagateStoreOptimisticData('samples');
          this.storeService.update$.next('samples');
        })
      );
  }
}
